// import axios from 'axios';
// import { useState } from 'react';
// import { useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { defNotifyDuration } from '../data/globals'
// import { define } from '../data/globals'

export function useNotify() {
    // Redux
    const dispath = useDispatch()
    // const notifyListStore = useSelector(state => state.notifyList)
    // const [authMsg, setAuthMsg] = useState('')

            // // Важно! Для React (актуально когда не используется Redux):
            // // При использовании setTimeout фильтруем notifyRef.current, а не notifyList. Поскольку при добавлении элементов в массив notifyList и запуске удаления через setTimeout, состояение notifyList не изменится к моменту запуска delNotify по таймеру. В такой ситуации используем useRef (см. 2 строки ниже) и фильтруем notifyRef.current с актуальными данными
            // // const notifyRef = useRef(notifyList);
            // // notifyRef.current = notifyList;
            // const notifyRef = useRef(notifyListStore);
            // notifyRef.current = notifyListStore;


    // Удаление уведомления
    function delNotify(id) {
        // Формируем массив
        // const filteredArr = notifyRef.current.filter(item => item.id !== id)
        // Сохраняем обновленный массив в сторе
        // dispath({ type: 'UpdateNotifyList', notifyList: filteredArr })
        dispath({ type: 'DeleteFromNotifyList', id: id })
        // setNotifyList( notifyListStore.filter(item => item.id !== id) )
    } // delNotify


    // Добавление уведомления
    function pushNotify(
        notifyText = "Default Notification Text", // текст уведомления (можно html)
        notifyClass = "notifyBlue", // цвета (стиль) уведомления
        notifyDuration = defNotifyDuration // продолжительность показа уведомления (в мс)
    ){
        // Добавляем уведомление
        let id = Date.now() // генерация уникального id
        let newNotify = { id: id, notifyText: notifyText, class: notifyClass }
        dispath({ type: 'AddNotify', newNotify: newNotify })
        // Удаляем через некоторое время
        setTimeout(()=>{
            delNotify(id)
        }, notifyDuration)
    } // pushNotify


    return { pushNotify, delNotify }
}